module.exports = __webpack_public_path__ + "static/media/07-Model-12-mobile.ac932fd3.webp";